export const RUN_AI_MODEL_MODES = {
  OPS: "ops",
  ANALYST: "analyst",
} as const;

export type RunAiModelMode =
  (typeof RUN_AI_MODEL_MODES)[keyof typeof RUN_AI_MODEL_MODES];

export const CLONE_REASONS = {
  RESTART: "restart",
  HUMAN_ANALYSIS: "human_analysis",
  AI_ANALYSIS: "ai_analysis",
} as const;

export type CloneReason = (typeof CLONE_REASONS)[keyof typeof CLONE_REASONS];

export type CloneReasonOption = {
  value: CloneReason;
  label: string;
};

export const DEFAULT_CLONE_REASON: CloneReason = CLONE_REASONS.RESTART;

export const CLONE_REASON_LABELS: Readonly<Record<CloneReason, string>> = {
  [CLONE_REASONS.RESTART]: "Restart",
  [CLONE_REASONS.HUMAN_ANALYSIS]: "Human Analysis",
  [CLONE_REASONS.AI_ANALYSIS]: "AI Analysis",
};

export const CLONE_REASON_OPTIONS: readonly CloneReasonOption[] = [
  {
    value: CLONE_REASONS.RESTART,
    label: CLONE_REASON_LABELS[CLONE_REASONS.RESTART],
  },
  {
    value: CLONE_REASONS.HUMAN_ANALYSIS,
    label: CLONE_REASON_LABELS[CLONE_REASONS.HUMAN_ANALYSIS],
  },
  {
    value: CLONE_REASONS.AI_ANALYSIS,
    label: CLONE_REASON_LABELS[CLONE_REASONS.AI_ANALYSIS],
  },
] as const;

export const METADOC_SEARCH_DEBOUNCE_MS = 300;
export const METADOC_FIRST_PAGE = 1;
export const METADOC_FOCUS_RESTORE_DELAY_MS = 100;
export const METADOC_GROUP_ID_PREFIX = "group-";
export const METADOC_ZOOM_DEFAULT_PERCENT = 100;

export const getCloneReasonLabel = (
  cloneReason?: CloneReason | null,
): string | null => {
  if (!cloneReason) {
    return null;
  }

  return CLONE_REASON_LABELS[cloneReason];
};

export const MEDICAL_RECORDS_DOCUMENT_TYPE =
  "Medical Records (include surgeries and procedures (injection))";
